import ReactPlayer from "react-player";
import {useParams, useNavigate} from "react-router-dom";
import {AppPage} from "common/Layout";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {
    getAdditionalMaterialsUrl,
    getAnnotationUrl, getHomeUrl,
    getInteractiveUrl,
    getLiteratureUrl, getMethodologicalModuleUrl,
    getPracticalModuleUrl,
    getTargetUrl, getTestUrl, getTheoryUrl, getVideoUrl
} from "services/navigation";
import type {
    InteractivePage,
    MethodologicalModulePage as MethodologicalModulePageType,
    Page, PracticalModulePage as PracticalModulePageType
} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

type IdParams = { id: string; }

export const MethodologicalModulePage = () => {
    const navigate = useNavigate();
    const {id} = useParams<IdParams>();
    const currentMethodologicalModule = GLOBAL_CONFIG.pages.find(
        page => page.type === PageType.METHODOLOGICAL_MODULE && page.id === id
    ) as MethodologicalModulePageType;

    if (!currentMethodologicalModule) {
        return null;
    }

    const getUrl = (page: Page) => {
        switch (page.type) {
            case PageType.ANNOTATION:
                return getAnnotationUrl();
            case PageType.INTERACTIVE:
                return getInteractiveUrl({id: (page as InteractivePage).id});
            case PageType.LITERATURE:
                return getLiteratureUrl();
            case PageType.TARGET:
                return getTargetUrl();
            case PageType.TEST:
                return getTestUrl();
            case PageType.THEORY:
                return getTheoryUrl();
            case PageType.VIDEO:
                return getVideoUrl();
            case PageType.METHODOLOGICAL_MODULE:
                return getMethodologicalModuleUrl({id: (page as MethodologicalModulePageType).id});
            case PageType.PRACTICAL_MODULE:
                return getPracticalModuleUrl({id: (page as PracticalModulePageType).id});
            case PageType.ADDITIONAL_MATERIALS:
                return getAdditionalMaterialsUrl();
            default:
                return getHomeUrl();
        }
    };

    const goToNextPage = () => {
        const nextPage = GLOBAL_CONFIG.pages.find(page => page.order === currentMethodologicalModule.order + 1);

        if (nextPage) {
            const url = getUrl(nextPage);
            navigate(url);
        }
    };

    return (
      <AppPage
            contentClassName={styles.content}
            pageTitle="Методический модуль"
            documentTitle="Методический модуль"
            style={{backgroundImage: `url(${currentMethodologicalModule.imagePath})`}}
        >
        <AppFlex unit="0" className={styles.container} justifyContent="flex-start">
          <AppText size={24}>{currentMethodologicalModule.title}</AppText>
          <div style={{fontSize: "18px", marginTop: "20px"}}>
            {
                        currentMethodologicalModule.contentBefore.map((item, index) => {
                            switch (item.type) {
                                case "block":
                                    return (
                                      <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                                      </div>
                                    );
                                case "text":
                                    return (
                                      <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                                      </div>
                                    );
                                default:
                                    return null;
                            }
                        })
                    }
          </div>
          {/*{id === "2" && (<AppText className={styles.videoLabel} size={18}>Видеофрагмент урока</AppText>)}*/}
          <ReactPlayer config={{file: {
                        attributes: {
                            disablePictureInPicture: true,
                            controlsList: "nodownload noremoteplayback noplaybackrate"
                        }
                    }}} className={styles.video} controls url={currentMethodologicalModule.videoUrl}/>
          <div style={{fontSize: "18px", marginTop: "20px"}}>
            {
                        currentMethodologicalModule.contentAfter.map((item, index) => {
                            switch (item.type) {
                                case "block":
                                    return (
                                      <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                                      </div>
                                    );
                                case "text":
                                    return (
                                      <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                                      </div>
                                    );
                                default:
                                    return null;
                            }
                        })
                    }
          </div>
          <AppButton className={styles.nextPageBtn} onClick={goToNextPage}>
            {currentMethodologicalModule.nextBtnName}
          </AppButton>
        </AppFlex>
      </AppPage>
    );
};
